<div class="card p-4 h-100">
    <p class="h6 text-center">Do you really want to delete this Sub Category?</p>
    <div class="ml-auto mt-auto">
        <button class="btn btn-sm btn-light mr-2" (click)="close()">Cancel</button>
        <button class="btn btn-sm btn-danger" (click)="delete()">Delete</button>
    </div>
</div>
